import { times } from 'lodash/fp';
import { StructuredMonth, StructuredYear } from './types';

export default () => {
    const getYearName = ({ year }: StructuredYear): number => year;
    const addYears = ({ year }: StructuredYear, count: number): StructuredYear => ({ year: year + count });
    const getYearOfMonth = ({ year }: StructuredYear): StructuredYear => ({ year });
    const getMonthsOfYear = ({ year }: StructuredYear): StructuredMonth[] => times((month) => ({ year, month }))(12);

    return {
        getYearName,
        addYears,
        getYearOfMonth,
        getMonthsOfYear,
    };
};
